import { NextRequest } from 'next/server';

import { COOKIE_NAMES } from './constants';

export const getExperimentsFromCookie = (
  request: NextRequest,
  key: 'featureFlags' | 'experimentPaths'
): Record<string, string> => {
  try {
    const experimentsCookie = request.cookies.get(
      COOKIE_NAMES.BOOTSTRAP_EXPERIMENTS
    )?.value;

    if (!experimentsCookie) {
      return {};
    }

    const parsed = JSON.parse(experimentsCookie);

    return parsed?.[key] || {};
  } catch (error) {
    return {};
  }
};
